/* -------------------------------------------------------------------
  **Usage Examples:

  generateCustomId();
  // → "d1f3d385-187e-4a0f-a431-09f159a5b9c5"

  generateCustomId({ prefix: "variant-" }); OR variantId: combo.id || generateCustomId("variant")
  // → "variant-1e12cfd6-f46f-45f0-b2fd-d23dc1571a1b"

  generateCustomId({ suffix: "-stocko" });
  // → "d75f3cbe-45b9-4cc6-86ff-b63cb0d9ebc1-stocko"

  generateCustomId({ prefix: "v-", suffix: "-prod" });
  // → "v-0a7424e4-bf8d-4323-b11c-cd6d5282f376-prod"

  generateCustomId({ generatorFn: () => `variant${Date.now()}` });
  // → "variant1722457022901"

  generateCustomId({
    prefix: "item-",
    generatorFn: () => `${Date.now()}`,
    suffix: "-dev"
  });
  // → "item-1722457022901-dev"

------------------------------------------------------------------- */

import { v4 as uuidv4 } from "uuid";

/**
 * Generate a custom ID based on UUID or a custom function, with optional prefix/suffix.
 * 
 * @param {Object} - Options for customizing the ID
 * @param {string} [options.prefix] - String to prepend to the ID
 * @param {string} [options.suffix] - String to append to the ID
 * @param {function} [options.generatorFn] - Optional custom generator function to replace UUID
 * 
 * @returns {string} - A unique ID string with optional prefix/suffix
 */
export function generateCustomId(options = {}) {
  const { prefix = "", suffix = "", generatorFn } = options;

  const coreId = typeof generatorFn === "function" ? generatorFn() : uuidv4();

  return `${prefix}${coreId}${suffix}`;
}